import { render, staticRenderFns } from "./AddVideoContainer.vue?vue&type=template&id=77c00e72&scoped=true&lang=pug&"
import script from "./AddVideoContainer.vue?vue&type=script&lang=js&"
export * from "./AddVideoContainer.vue?vue&type=script&lang=js&"
import style0 from "./AddVideoContainer.vue?vue&type=style&index=0&id=77c00e72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c00e72",
  null
  
)

export default component.exports